import React, { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

import Navbar from "./components/Navbar";
import Footer from "./components/Footer";

import About from "./pages/About";
import Projects from "./pages/Projects";
import Contact from "./pages/Contact";

function App() {
  const [isLight, setIsLight] = useState(true);

  useEffect(() => {
    const interf = JSON.parse(localStorage.getItem("interface"));
    interf !== null ? setIsLight(interf) : setIsLight(true);
  }, []);

  const setInterface = () => {
    const interf = JSON.parse(localStorage.getItem("interface"));
    setIsLight(!interf);
    localStorage.setItem("interface", !interf);
  };

  const getInterface = () => {
    return JSON.parse(localStorage.getItem("interface"));
  };

  return (
    <BrowserRouter>
      <div
        className={`flex flex-col w-full min-h-screen ${
          getInterface() ? "" : "bg-gray-800 text-gray-300"
        }`}
      >
        <Navbar
          isLight={isLight}
          setInterface={setInterface}
          getInterface={getInterface}
        />
        <div className={`flex-grow`}>
          <Routes>
            <Route path="/" element={<Navigate to="/about" replace />} />
            <Route
              path="/about"
              element={<About getInterface={getInterface} />}
            />
            <Route
              path="/projects"
              element={<Projects getInterface={getInterface} />}
            />
            <Route
              path="/contact"
              element={<Contact getInterface={getInterface} />}
            />
            <Route path="*" element={<Navigate to="/404" replace />} />
          </Routes>
        </div>
        <Footer getInterface={getInterface} />
      </div>
    </BrowserRouter>
  );
}

export default App;
